<script setup>
    import __ from '@components/../mixins/locale'
    import axios from 'axios'
    import { ref } from 'vue'
    
    const props = defineProps({
        userId: {
            type: Number,
            default () {
                return null
            },
            required: false
        },
        storyId: {
            type: Number,
            required: true
        },
        currentUserStoryRating: {
            type: Number,
            default () {
                return 0
            },
            required: true
        }
    });

    const user = ref(props.userId);

    const story = ref(props.storyId);

    const rating = ref(props.currentUserStoryRating);

    const rated = ref(0);

    const loading = ref(false);

    const update = (updatedRating) => {
        console.log(updatedRating, rating.value);
        if(!rating.value){
            loading.value = true;
            axios.post(`/api/story/ratings`, {
                'userId': user.value,
                'rating': updatedRating,
                'storyId': story.value
            }).then(response => {
                if(response.data && response.data === 'register') {
                    window.open('/register', '_self');
                } else {
                    rating.value = updatedRating;
                    rated.value = 1;
                    loading.value = false;
                }
            });
        }
    }

    const isHighlighted = (updatedRating) => {
        return (updatedRating <= rating.value) ? 1 : 0;
    }

    const isRated = () => {
        return (rating.value !== 0) ? 1 : 0;
    }
</script>

<template>
    <div class="jumbotron rating rate-it" v-bind:class="[{ rated: isRated(), 'text-center': loading }]">
        <span id="rate-story" class="anchor-link"></span>
        <div v-if="loading">
            <div class="loading-indicator"><div></div><div></div><div></div></div>
        </div>
        <div v-else>
            <h3 v-if="currentUserStoryRating && !loading">{{ __('You rated it!') }}</h3>
            <h3 v-if="!rating && !currentUserStoryRating && !loading">{{ __('Enjoyed reading? Why not reward the author and give it a rating?') }}</h3>
            <h3 v-if="rating && !currentUserStoryRating && !loading">{{ __('Thank you for your rating!') }}</h3>
            <span v-if="!loading" v-bind:class="[{ highlighted: isHighlighted(1) }]" @click="update(1)">&#9733;</span>
            <span v-bind:class="[{ highlighted: isHighlighted(2) }]" @click="update(2)">&#9733;</span>
            <span v-bind:class="[{ highlighted: isHighlighted(3) }]" @click="update(3)">&#9733;</span>
            <span v-bind:class="[{ highlighted: isHighlighted(4) }]" @click="update(4)">&#9733;</span>
            <span v-bind:class="[{ highlighted: isHighlighted(5) }]" @click="update(5)">&#9733;</span>
        </div>
    </div>
</template>